import { Stethoscope, Siren, Scissors, Heart, Home, Footprints, ShoppingBag, Sun, Building, GraduationCap, Hospital, LucideIcon } from 'lucide-react';

export interface ServiceCategory {
  id: string;
  type: string; // Provider type(s) for search
  icon: string; // Emoji for Services page
  lucideIcon: LucideIcon; // Lucide icon for modal
  titleKey: string; // Translation key for title
  descKey: string; // Translation key for description
  color: string; // Color gradient classes
  iconColor: string; // Icon color class for modal
  emergency?: boolean; // Special emergency flag
}

export const SERVICE_CATEGORIES: ServiceCategory[] = [
  {
    id: 'veterinarian',
    type: 'veterinarian_individual',
    icon: '🧑‍⚕️',
    lucideIcon: Stethoscope,
    titleKey: 'services.veterinarian',
    descKey: 'services.veterinarianDesc',
    color: 'from-blue-500 to-blue-600',
    iconColor: 'text-blue-600',
  },
  {
    id: 'veterinary_clinic',
    type: 'veterinary_clinic',
    icon: '🏥',
    lucideIcon: Hospital,
    titleKey: 'services.veterinaryClinic',
    descKey: 'services.veterinaryClinicDesc',
    color: 'from-cyan-500 to-cyan-600',
    iconColor: 'text-cyan-600',
  },
  {
    id: 'emergency',
    type: 'veterinary_clinic',
    icon: '🚨',
    lucideIcon: Siren,
    titleKey: 'services.emergency',
    descKey: 'services.emergencyDesc',
    color: 'from-red-500 to-red-600',
    iconColor: 'text-red-600',
    emergency: true,
  },
  {
    id: 'grooming',
    type: 'grooming_spa',
    icon: '🛁',
    lucideIcon: Scissors,
    titleKey: 'services.grooming',
    descKey: 'services.groomingDesc',
    color: 'from-purple-500 to-purple-600',
    iconColor: 'text-purple-600',
  },
  {
    id: 'dog_walker',
    type: 'dog_walker',
    icon: '🚶',
    lucideIcon: Footprints,
    titleKey: 'services.walker',
    descKey: 'services.walkerDesc',
    color: 'from-teal-500 to-teal-600',
    iconColor: 'text-teal-600',
  },
  {
    id: 'pet_store',
    type: 'pet_store',
    icon: '🛒',
    lucideIcon: ShoppingBag,
    titleKey: 'services.petStore',
    descKey: 'services.petStoreDesc',
    color: 'from-orange-500 to-orange-600',
    iconColor: 'text-orange-600',
  },
  {
    id: 'daycare',
    type: 'daycare_hotel',
    icon: '☀️',
    lucideIcon: Sun,
    titleKey: 'services.daycare',
    descKey: 'services.daycareDesc',
    color: 'from-yellow-500 to-yellow-600',
    iconColor: 'text-yellow-600',
  },
  {
    id: 'pet_hotel',
    type: 'daycare_hotel',
    icon: '🏨',
    lucideIcon: Building,
    titleKey: 'services.petHotel',
    descKey: 'services.petHotelDesc',
    color: 'from-indigo-500 to-indigo-600',
    iconColor: 'text-indigo-600',
  },
  {
    id: 'training',
    type: 'school_training',
    icon: '🎓',
    lucideIcon: GraduationCap,
    titleKey: 'services.training',
    descKey: 'services.trainingDesc',
    color: 'from-green-500 to-green-600',
    iconColor: 'text-green-600',
  },
];
